export default __webpack_public_path__ + "static/media/LevelDown.4024a228.svg";